import { ComponentPropsWithoutRef, Dispatch, SetStateAction, useState } from 'react';

import './InputAnimated.scss';

interface InputAnimatedProps extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange'> {
  setState: Dispatch<SetStateAction<string>>;
  value: string;
  placeholder: string;
  image?: string;
  confirmFunction: () => void;
  discardFunction: () => any;
}

function InputAnimatedConfirm({
  className,
  placeholder,
  value,
  setState,
  image,
  confirmFunction,
  discardFunction,
  ...rest
}: InputAnimatedProps) {
  const [isConfirmButtonVisible, setIsConfirmButtonVisible] = useState<boolean>(false);

  function discard() {
    discardFunction();
    setIsConfirmButtonVisible(false);
  }

  function onFocus() {
    setIsConfirmButtonVisible(true);
  }

  function onFocusLost() {
    if (value === '') {
      setTimeout(() => {
        setIsConfirmButtonVisible(false);
      }, 200);
    }
  }
  return (
    <div className={`custom-input-container ${className}`}>
      <input
        placeholder=" "
        value={value}
        onChange={e => setState(e.target.value)}
        onFocus={onFocus}
        onBlur={onFocusLost}
        {...rest}
      />
      <div className="placeholder">{placeholder}</div>
      {isConfirmButtonVisible && (
        <div className="buttons-container">
          {image && <img src={image} alt={image} />}
          <button onClick={confirmFunction}>Confirm</button>
          <button onClick={discard}>Discard</button>
        </div>
      )}
    </div>
  );
}

export default InputAnimatedConfirm;
